<template>
  <div class="person bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">
      {{ $t('personalInformation') }} > {{ $t('PersonalSettings') }}
      <el-tooltip class="item" :effect="isDefaultTheme ? 'light' : 'dark'" placement="bottom">
        <div slot="content">
          <p>1.{{ $t('loginPasswordAccount') }}</p>
          <p>2.{{ $t('setWhetherWeb') }}</p>
          <p v-if="!isOnlySupportPosition">3.{{ $t('messagesWithinRange') }}</p>
        </div>
        <i class="help_icon"></i>
      </el-tooltip>
    </div>

    <div class="main-content common-table-cnt">
      <div class="bind search">
        <div class="self">
          <div class="name" v-if="isHuaWei">
            <span>{{ $t('fullName') }}：</span>
            <span>{{ userInfo.name }}</span>
          </div>
          <i v-if="isHuaWei"></i>
          <div class="department">
            <span>{{ $t('department') }}：</span>
            <span>{{ userInfo.ouName }}</span>
          </div>
          <i></i>
          <div class="department">
            <span>{{ $t('accountRole') }}：</span>
            <span>{{ $t(userInfo.roleNames )}}</span>
          </div>
        </div>
        <div :class="getPhoneBindClass()">
          <div class="label-bind">
            <span>{{ $t('loginaccount') }}</span>
          </div>
          <div class="content-bind">
            <span class="explain"> 【{{ userInfo.account }}】 </span>
          </div>
          <div class="bind-btn">
            <el-button size="mini" type="primary" @click="pwdDialogVisible = true">{{
              $t('changePassword')
            }}</el-button>
          </div>
        </div>
        <!-- 公有云专有模块 开始  -->
        <div v-if="isCloud">
          <div :class="getPhoneBindClass()" v-if="isHuaWei">
            <div class="label-bind">
              <span>{{ $t('mobilePhoneBinding') }}</span>
            </div>
            <div class="content-bind">
              <span class="explain"
                >{{ phoneBound ? $t('haveBoundMobile') + '【' + phone + '】' : $t('haveNotBoundMobile') }}
              </span>
            </div>
            <div class="bind-btn">
              <el-button size="mini" type="primary" @click="toUnbound(phoneBound)">{{
                phoneBound ? $t('unbinding') : $t('toUnbind')
              }}</el-button>
            </div>
          </div>
          <div :class="getPhoneBindClass()" v-if="isHuaWei">
            <div class="label-bind">
              <span>{{ $t('weChatBinding') }}</span>
            </div>
            <div class="content-bind">
              <span class="explain">{{
                weixinBound
                  ? $t('haveBoundWeChat') + (!userInfo.wxNickName ? '' : '【' + userInfo.wxNickName + '】')
                  : $t('haveNotBoundWeChat')
              }}</span>
            </div>
            <div class="bind-btn">
              <el-button size="mini" type="primary" @click="WechatBound(weixinBound)">{{
                weixinBound ? $t('unbinding') : $t('toUnbind')
              }}</el-button>
            </div>
          </div>

          <div :class="getPhoneBindClass()" v-if="checkIsAdmin() && checkDeviceType(['1', '2', '3'])">
            <div class="label-bind">
              <span>{{ $t('videoMonitoringMode') }}</span>
            </div>
            <div class="content-bind">
              {{ liveMode === 'FLV' ? $t('standardLiveBroadcast') : $t('live') }}
            </div>
            <div class="bind-btn">
              <el-button size="mini" type="primary" @click="updateTranscribe('TRANSCRIBE_LIVE_MODE', liveMode)">{{
                $t('toggleMode')
              }}</el-button>
            </div>
          </div>

          <div :class="getPhoneBindClass()" v-if="DEVICE_SPEC_TYPE && isHuaWei">
            <div class="label-bind">
              <span>{{ $t('officialAccountReceivAlarm') }}</span>
            </div>
            <div class="content-bind">
              {{ wxAlert === '1' ? $t('openP') : $t('closeP') }}
            </div>
            <div class="bind-btn">
              <el-switch
                v-model="wxAlert"
                active-color="#0E65DD"
                inactive-color="#B3B3B3"
                active-value="1"
                inactive-value="0"
                @change="updateUserInfo(false)"
              >
              </el-switch>
            </div>
          </div>
          <div :class="getPhoneBindClass()" v-if="DEVICE_SPEC_TYPE && isHuaWei">
            <div class="label-bind">
              <span>{{ $t('smsReceivingAlarm') }}</span>
            </div>
            <div class="content-bind">
              {{ smsAlert === '1' ? $t('openP') : $t('closeP') }}
            </div>
            <div class="bind-btn">
              <el-switch
                v-model="smsAlert"
                active-color="#0E65DD"
                inactive-color="#B3B3B3"
                active-value="1"
                inactive-value="0"
                @change="updateUserInfo(false)"
              >
              </el-switch>
            </div>
          </div>
        </div>
        <!-- 公有云专有模块 结束-->

        <div :class="getPhoneBindClass()">
          <div class="label-bind">
            <span>{{ $t('browserReceivesAlarm') }}</span>
          </div>
          <div class="content-bind">
            {{ webAlert === '1' ? $t('openP') : $t('closeP') }}
          </div>
          <div class="bind-btn">
            <el-switch
              v-model="webAlert"
              active-color="#0E65DD"
              inactive-color="#B3B3B3"
              active-value="1"
              inactive-value="0"
              @change="updateUserInfo(false)"
            >
            </el-switch>
          </div>
        </div>
        <div :class="getPhoneBindClass()" v-if="checkIsAdmin() && checkDeviceType(['1', '2'])">
          <div class="label-bind">
            <span>{{ $t('timevideoRecording') }}</span>
          </div>
          <div class="content-bind">
            {{ realFlag === 'true' ? $t('openP') : $t('closeP') }}
          </div>
          <div class="bind-btn">
            <el-switch
              v-model="realFlag"
              active-color="#0E65DD"
              inactive-color="#B3B3B3"
              active-value="true"
              inactive-value="false"
              @change="updateTranscribe('TRANSCRIBE_REAL_VIDEO', realFlag)"
            >
            </el-switch>
          </div>
        </div>
        <div :class="getPhoneBindClass()" v-if="checkIsAdmin() && checkDeviceType(['1', '2', '3'])">
          <div class="label-bind">
            <span>{{ $t('monitoringRecording') }}</span>
          </div>
          <div class="content-bind">
            {{ liveFlag === 'true' ? $t('openP') : $t('closeP') }}
          </div>
          <div class="bind-btn">
            <el-switch
              v-model="liveFlag"
              active-color="#0E65DD"
              inactive-color="#B3B3B3"
              active-value="true"
              inactive-value="false"
              @change="updateTranscribe('TRANSCRIBE_LIVE', liveFlag)"
            >
            </el-switch>
          </div>
        </div>
        <!--   公有云关闭开放接口相关内容-->

        <div :class="getPhoneBindClass()" v-if="!isOnlySupportPosition">
          <div class="label-bind">
            <span>{{ $t('messageReceivingRange') }}</span>
          </div>
          <div class="content-bind">
            {{ subscriptionOuNames }}
          </div>
          <div class="bind-btn">
            <el-button size="mini" type="primary" @click="openSetAlert">{{ $t('setUp') }}</el-button>
          </div>
        </div>

        <div :class="getPhoneBindClass()">
          <div class="label-bind">
            <span>{{ $t('APISecretKey') }}</span>
          </div>
          <div class="content-bind">
            <!-- <span v-if="checkIsAdmin() && webHookUrl"> WEBHOOK：{{ webHookUrl }} </span> -->
            <span>————</span>
          </div>
          <div class="bind-btn long-bind-btn">
            <el-button size="mini" type="primary" @click="showSecret">{{ $t('APISecretKey') }}</el-button>
          </div>
        </div>
        <div :class="getPhoneBindClass()" v-if="checkIsAdmin()">
          <div class="label-bind">
            <span>{{ $t('webHook') }}</span>
          </div>
          <div class="content-bind">
            <span v-if="checkIsAdmin() && webHookUrl"> WEBHOOK：{{ webHookUrl }} </span>
            <span v-else>————</span>
          </div>
          <div class="bind-btn long-bind-btn">
            <el-button size="mini" class="webhook-btn" type="primary" @click="showWebHook" v-if="checkIsAdmin()"
              >{{ $t('setUp') }} webHook</el-button
            >
          </div>
        </div>
      </div>
      <div class="code-img search" v-if="isHuaWei">
        <div class="scan-code" @click="gotoDownload" v-if="checkDeviceType(['0'])">
          <p class="scan-title">{{ $t('officialAccount') }}</p>
          <img src="@/icon/account.png" alt="" />
        </div>
        <div class="scan-code" @click="gotoDownload" v-if="checkDeviceType(['0'])">
          <p class="scan-title">{{ $t('terminalApplet') }}</p>
          <img src="@/icon/applets.png" alt="" />
        </div>
        <div class="scan-code" @click="gotoDownload('lanya')" v-if="checkDeviceType(['1', '2', '3'])">
          <p class="scan-title">{{ $t('remoteControl') }}</p>
          <img class="app-img" src="@/icon/blueTooth.png" alt="" />
          <p class="scan-tip">{{ $t('browserScan') }}</p>
        </div>
        <div class="scan-code" @click="gotoDownload('app')" v-if="checkDeviceType(['1', '2', '3'])">
          <p class="scan-title">{{ $t('operationIntelligentPlatform') }}</p>
          <img class="app-img" src="@/icon/androidApp.png" alt="" />
          <p class="scan-tip">{{ $t('browserScan') }}</p>
        </div>
        <div class="scan-code" @click="handleToHelp" v-if="isCloud">
          <p class="scan-title">{{ $t('helpDocuments') }}</p>
          <img class="help-img" src="@/icon/helpQrCode.png" alt="" />
        </div>
        <div class="scan-code" @click="handleToApi" v-if="isCloud">
          <p class="scan-title">{{ $t('ApiDocuments') }}</p>
          <img class="help-img" src="@/icon/apiQrCode.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 绑定/解绑手机号 -->
    <el-dialog
      :title="phoneBound ? $t('unbindingmobilePhone') : $t('bindMobileNumber')"
      :visible.sync="phoneVisible"
      width="500px"
      class="common-blue-contain"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form :model="formBind" label-width="160px" width="100%">
        <el-form-item :label="$t('phoneNumber')">
          <el-input
            v-model="formBind.phone"
            clearable
            :placeholder="$t('pleaseEnter') + $t('phoneNumber')"
            :disabled="phoneBound ? true : false"
            style="width: 280px !important;"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('verificationcode')" label-width="160px" class="verificat-code">
          <el-input
            v-model="formBind.smsCode"
            clearable
            :placeholder="$t('pleaseEnter') + $t('verificationcode')"
            style="width: 280px !important;"
          ></el-input>
          <span class="phoneCode" :disabled="disabled" @click="getsmsCode('unbind')" v-if="phoneBound">{{
            btnTxt
          }}</span>
          <span class="phoneCode" :disabled="disabled" @click="getsmsCode('bind')" v-else>{{ btnTxt }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="phoneSubmit">{{ $t('determine') }}</el-button>
        <el-button @click="cancelBind">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 绑定/解绑微信 -->
    <el-dialog
      :title="$t('bindWeChat')"
      :visible.sync="WechatVisible"
      class="common-blue-contain"
      width="560px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div id="wxbox" @click="WechatBound(false)">
        <wxlogin
          :appid="appid"
          :scope="scope"
          :redirect_uri="encodeURIComponent(qrcodeUrl)"
          :state="state"
          :href="
            'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLmluZm8gewogY29sb3I6ICM2NjYKfQ=='
          "
        ></wxlogin>
      </div>
    </el-dialog>
    <!-- 设置订阅机构 -->
    <el-dialog
      :title="$t('selectYouOrganization')"
      :visible.sync="setAlertVisible"
      width="35%"
      class="common-blue-contain"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div id="setAlertBox">
        <el-tree
          ref="ouTree"
          show-checkbox
          node-key="id"
          default-expand-all
          :data="ouList"
          :check-strictly="true"
          :check-on-click-node="true"
          :default-checked-keys="userInfo.subscriptionOuIds"
          :props="ouTreeProps"
        >
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateUserInfo(true)">{{ $t('determine') }}</el-button>
        <el-button @click="cancelUpdate">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--重置密码窗口-->
    <el-dialog
      :title="$t('changePersonalPassword')"
      :visible.sync="pwdDialogVisible"
      width="520px"
      :append-to-body="true"
      class="resetPasswordDialog common-blue-contain"
      @close="cancelUpdatePwd('pwdForm')"
      :close-on-click-modal="false"
    >
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm">
        <div class="">
          <el-form-item :label="$t('oldPassword')" :label-width="formLabelWidth" prop="oldPwd">
            <el-input
              v-model="pwdForm.oldPwd"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('oldPassword')"
              style="width: 280px !important;"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('newPassword')" :label-width="formLabelWidth" prop="newPwd">
            <el-input
              v-model="pwdForm.newPwd"
              autocomplete="off"
              :placeholder="$t('pleaseEnter') + $t('newPassword')"
              style="width: 280px !important;"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('confirmNewpassword')" :label-width="formLabelWidth" prop="checkPwd">
            <el-input
              v-model="pwdForm.checkPwd"
              autocomplete="off"
              :placeholder="$t('enterPasswordAgain')"
              style="width: 280px !important;"
              show-password
            ></el-input>
            <span v-if="checkPassSame">{{ $t('passwordsEnteredTwice') }}</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePwd('pwdForm')">{{ $t('determine') }}</el-button>
        <el-button @click="cancelUpdatePwd('pwdForm')">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- API秘钥 -->
    <el-dialog
      :title="$t('APISecreKey')"
      :visible.sync="secretVisible"
      width="90%"
      class="common-blue-contain"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <ApiSet></ApiSet>
    </el-dialog>
    <!-- 设置webhook -->
    <el-dialog
      :title="$t('setUp') + 'webhook'"
      :visible.sync="webHookVisible"
      width="600px"
      class="common-blue-contain"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form :model="formWebHook" label-width="130px" width="100%">
        <el-form-item :label="$t('tokenUrl')">
          <el-input
            v-model="formWebHook.url"
            clearable
            :placeholder="$t('pleaseEnter') + ' webhook' + $t('tokenUrl')"
            style="width: 100% !important;"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveWebHook">{{ $t('determine') }}</el-button>
        <el-button @click="webHookVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getUrlParam, setSession } from '@/api/common'
import wxlogin from 'vue-wxlogin'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { mapGetters } from 'vuex'
import ApiSet from '@/views/new-set/personal-setting/ApiSet.vue'
import { encrypt } from '@/util/rsaEncryptor'
import {
  phoneBind,
  getUserInfo,
  phoneUnbind,
  getQrCode,
  wxBind,
  wxUnBind,
  updateUserInfo,
  updatePwd,
  saveWebHook,
  updateWebHook,
  getWebHook,
  getTranscribe,
  updateTranscribe,
} from '@/api/personal'
import { smsSend } from '@/api/login'
import { getOus } from '@/api/UserList'
import { deepClone } from '@/util/Utils'
import { errorMessage } from '@/util/common'
export default {
  components: {
    wxlogin,
    ApiSet,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        errorCollection('个人设置', '修改个人密码', { status: 200, data: { state: -1, msg: '请输入新密码' } })
        callback(new Error(this.$t('pleaseInputPassword')))
      } else {
        if (!this.pwdForm.checkPwd) {
          this.$refs.pwdForm.validateField('checkPwd')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        errorCollection('个人设置', '修改个人密码', { status: 200, data: { state: -1, msg: '请再次输入密码' } })
        callback(new Error(this.$t('enterPasswordAgain')))
      } else if (value !== this.pwdForm.newPwd) {
        errorCollection('个人设置', '修改个人密码', { status: 200, data: { state: -1, msg: '两次输入密码不一致' } })
        callback(new Error(this.$t('passwordsEnteredTwice')))
      } else {
        callback()
      }
    }
    return {
      phoneBound: false,
      weixinBound: false,
      phoneVisible: false,
      secretVisible: false,
      webHookVisible: false,
      realFlag: 'false',
      liveFlag: 'false',
      // 直播模式: 默认为快直播模式
      liveMode: 'WEBRTC',
      webHookUrl: '',
      // 设置webhook参数
      formWebHook: {
        id: '',
        url: '',
      },
      // 绑定/解绑手机号参数
      formBind: {
        phone: '',
        smsCode: '',
      },
      // 用户信息源
      originUserInfo: {},
      // 个人信息 > 个人设置的详细信息
      userInfo: {},
      // 绑定手机的手机号码
      phone: '',
      // 绑定/解绑微信弹窗显示
      WechatVisible: false,
      WechatCode: [],
      // 微信二维码url 重定向地址，需要进行UrlEncode
      qrcodeUrl: '',
      // 微信二维码绑定需要参数，应用授权作用域
      scope: '',
      // 微信应用唯一标识，在微信开放平台提交应用审核通过后获得
      appid: '',
      // 绑定手机号 获取验证码的按钮是否可点击
      disabled: false,
      // 绑定手机号 验证码倒计时
      time: 60,
      // 手机绑定时获取验证码时的文字
      btnTxt: this.$t('getVerificationCode'),
      //  微信二维码url
      href: '',
      qrcode: '',
      qrState: '',
      routeNow: '',
      wxAlert: '0',
      webAlert: '0',
      smsAlert: '0',
      // 显示接收告警的组织机构 的弹窗
      setAlertVisible: false,
      ouTreeProps: {
        label: 'name',
        children: 'children',
      },
      ouList: [],
      // 表单lable的宽度
      formLabelWidth: '185px',
      // 显示重置密码 的弹窗与否
      pwdDialogVisible: false,
      // 修改个人密码参数
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        checkPwd: '',
      },
      // 显示两字输入密码不一致的提示语
      checkPassSame: false,
      // 输入密码的规则
      pwdRules: {
        oldPwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        newPwd: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 8, message: this.$t('enterLeastCharacters'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
              if (!passwordreg.test(value)) {
                callback(new Error(this.$t('letterSpecialCharacters')))
              } else {
                callback()
              }
            },
          },
        ],
        checkPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
      // 获取当前系统的颜色系
      theme: localStorage.getItem('theme'),
      state: '',
      // 语音消息接收范围数组
      subscriptionOuNames: [],
      // 定义定时执行参数
      myVar: '',
      // API秘钥 参数
      formInline: {
        ak: '',
        enable: null,
      },
      // API秘钥 table数据
      secretData: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
    }
  },
  methods: {
    handleToHelp() {
      window.open('https://intranet.iot.huaweisoft.com:6965/help/icpfo-platform/web.html', '_blank')
    },
    handleToApi() {
      window.open('https://intranet.iot.huaweisoft.com:6965/doc/authorization/detail.html', '_blank')
    },
    getUrl(name, url) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    gotoDownload(val) {
      if (val && val === 'lanya') {
        window.open('https://intranet.iot.huaweisoft.com:6965/help/icpfo-bluetooth/home.html', '_blank')
      } else if (val && val === 'app') {
        window.open('https://intranet.iot.huaweisoft.com:6965/help/icpfo-app/home.html', '_blank')
      } else {
        const routeUrl = this.$router.resolve({
          path: '/download',
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    formatDate() {
      let date = new Date()
      if (date > new Date(this.WechatCode.expiration)) {
        this.WechatBound(false)
        // 清除定时装置
        clearInterval(this.myVar)
      }
      if (this.WechatVisible === false) {
        clearInterval(this.myVar)
      }
    },
    // 获取表格高度样式
    getPhoneBindClass() {
      // 从浏览器缓存中获取是否为超级管理用户
      if (this.checkIsAdmin()) {
        return 'phone-bind phone-bind-line-height-admin'
      }
      return 'phone-bind phone-bind-line-height'
    },
    // 微信获取二维码/解绑
    WechatBound(type) {
      if (type === true) {
        this.$confirm(this.$t('unbindTheWeChat'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            wxUnBind().then(res => {
              if (res.state === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('unbindingWeChatSucceed'),
                  duration: 1000,
                })
                this.getUserInfo()
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('unboundC'),
            })
          })
      } else {
        if (window.document.location.hash.indexOf('?')) {
          let routeUrl = window.document.location.hash.split('?')
          this.routeNow = routeUrl[0]
        }
        let wPath = window.document.location.origin + '/' + this.routeNow
        console.log(wPath)
        let param = new FormData()
        // param.append('redirectUrl','https://jls.huaweisoft.com/#/personal')
        param.append('redirectUrl', wPath)
        param.append('state', 'wxBind')
        getQrCode(param).then(res => {
          if (res.state === 0) {
            this.WechatCode = res.data
            this.appid = this.getUrl('appid', res.data.qrcodeUrl)
            this.scope = this.getUrl('scope', res.data.qrcodeUrl)
            this.state = this.getUrl('state', res.data.qrcodeUrl)
            this.qrcodeUrl = this.getUrl('redirect_uri', res.data.qrcodeUrl)
            this.WechatVisible = true
            this.getUserInfo()
            this.myVar = setInterval(this.formatDate, 1000)
          }
        })
      }
    },
    cancelBind() {
      this.phoneVisible = false
      this.formBind = {
        phone: '',
        smsCode: '',
      }
    },
    // 获取手机验证码
    getsmsCode(type) {
      this.time = 60
      let param = new FormData()
      param.append('phone', this.formBind.phone)
      param.append('type', type)
      smsSend(param).then(res => {
        if (res.state === 0) {
          this.$message({
            type: 'success',
            message: this.$t('scceededObtainingMobile'),
            duration: 1000,
          })
          this.timer()
        }
      })
    },
    // 取消重置密码
    cancelUpdatePwd(formName) {
      this.pwdDialogVisible = false
      this.checkPassSame = false
      this.$nextTick(function() {
        this.$refs[formName].resetFields()
      })
    },
    // 提交密码
    savePwd() {
      this.$refs.pwdForm.validate(valid => {
        if (valid) {
          if (this.pwdForm.newPwd !== this.pwdForm.checkPwd) {
            this.checkPassSame = true
          } else {
            this.checkPassSame = false
            let form = new FormData()
            form.append('oldPwd', encrypt(this.pwdForm.oldPwd))
            form.append('newPwd', encrypt(this.pwdForm.newPwd))
            updatePwd(form).then(res => {
              if (res.state === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('passwordUpdatedSuccess'),
                })
                this.pwdDialogVisible = false
                this.checkPassSame = false
              }
            })
          }
        } else {
          return false
        }
      })
    },
    timer() {
      if (this.time > 0) {
        this.disabled = true
        this.time--
        this.btnTxt = this.time + this.$t('seconds')
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btnTxt = this.$t('sendVerificationCode')
        this.disabled = false
      }
    },
    // 手机解绑
    toUnbound() {
      if (this.userInfo.phone && this.userInfo.phone !== '') {
        phoneUnbind().then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('unbindingMobilePhone'),
              duration: 1000,
            })
            this.getUserInfo()
          }
        })
      } else {
        this.phoneVisible = true
      }
    },
    // 手机提交绑定
    phoneSubmit() {
      let param = new FormData()
      param.append('phone', this.formBind.phone)
      param.append('code', this.formBind.smsCode)
      if (!this.phoneBound) {
        phoneBind(param).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('numberBindingSucceed'),
              duration: 1000,
            })
            this.phoneVisible = false
            this.getUserInfo()
            this.formBind = {
              phone: '',
              smsCode: '',
            }
          }
        })
      }
    },
    // 获取个人信息
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.state === 0) {
          this.originUserInfo = deepClone(res.data)
          this.userInfo = res.data
          this.phoneBound = !this.userInfo.phone ? false : true
          this.weixinBound = this.userInfo.bindWx === 0 ? false : true
          this.subscriptionOuNames = this.userInfo.subscriptionOuNames
          this.isAlertNUll()
        }
      })
    },
    // 获取租户直播、实时视频录制配置
    getTranscribe() {
      getTranscribe().then(res => {
        if (res.state === 0) {
          if (res.data) {
            for (let item of res.data) {
              if (item.transcribe == 'TRANSCRIBE_REAL_VIDEO') {
                this.realFlag = item.value
                setSession('TRANSCRIBE_REAL_VIDEO', this.realFlag)
              }
              if (item.transcribe == 'TRANSCRIBE_LIVE') {
                this.liveFlag = item.value
                setSession('TRANSCRIBE_LIVE', this.liveFlag)
              }
              if (item.transcribe == 'TRANSCRIBE_LIVE_MODE') {
                this.liveMode = item.value
                this.$store.commit('changeLiveMode', item.value)
              }
            }
          }
        }
      })
    },
    isAlertNUll() {
      if (this.userInfo.phone !== null) {
        this.phone =
          this.userInfo.phone !== ''
            ? this.userInfo.phone.substr(0, 3) + '****' + this.userInfo.phone.substr(this.userInfo.phone.length - 4)
            : ''
      }
      if (this.userInfo.wxAlert !== null) {
        this.wxAlert = this.userInfo.wxAlert + ''
      }
      if (this.userInfo.webAlert !== null) {
        this.webAlert = this.userInfo.webAlert + ''
      }
      if (this.userInfo.smsAlert !== null) {
        this.smsAlert = this.userInfo.smsAlert + ''
      }
    },
    // 微信绑定
    toBound() {
      this.qrcode = getUrlParam('code')
      this.qrState = getUrlParam('state')
      if (this.qrcode !== null && this.qrState !== null) {
        let param = new FormData()
        param.append('code', this.qrcode)
        param.append('state', this.qrState)
        wxBind(param).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('weChatBindingSucceed'),
              duration: 1000,
            })
            this.getUserInfo()
            this.WechatVisible = false
          } else {
            this.WechatVisible = false
          }
          clearInterval(this.myVar)
        })
      }
    },
    // 打开告警设置弹窗
    openSetAlert() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
          this.setAlertVisible = true
        }
      })
    },
    // 更新用户信息
    updateUserInfo(updateOu) {
      if (updateOu) {
        let selectNode = this.$refs.ouTree.getCheckedNodes()
        let ouIds = []
        for (let item of selectNode) {
          ouIds.push(item.id)
        }
        if (this.userInfo.subscriptionOuIds && ouIds.length === this.userInfo.subscriptionOuIds.length) {
          let ouIdsStr = ouIds.join(',')
          let subscriptionOuIdsStr = this.userInfo.subscriptionOuIds.join(',')
          if (ouIdsStr === subscriptionOuIdsStr) {
            this.setAlertVisible = false
            return
          }
        }
        this.userInfo.subscriptionOuIds = ouIds
      } else {
        this.userInfo.wxAlert = this.wxAlert
        this.userInfo.webAlert = this.webAlert
        this.userInfo.smsAlert = this.smsAlert
      }
      let param = this.userInfo
      updateUserInfo(param).then(res => {
        if (res.state === 0) {
          this.setAlertVisible = false
          this.getUserInfo()
        } else {
          this.userInfo = deepClone(this.originUserInfo)
        }
      })
    },
    // 更新租户录制视频配置
    updateTranscribe(key, value) {
      let param = {
        transcribe: key,
        value: value,
      }
      let mode = value === 'FLV' ? this.$t('live') : this.$t('standardLiveBroadcast')
      switch (key) {
        case 'TRANSCRIBE_REAL_VIDEO':
          this.realFlag = value
          setSession('TRANSCRIBE_REAL_VIDEO', this.realFlag)
          updateTranscribe(param)
          break
        case 'TRANSCRIBE_LIVE':
          this.liveFlag = value
          setSession('TRANSCRIBE_LIVE', this.liveFlag)
          updateTranscribe(param)
          break
        case 'TRANSCRIBE_LIVE_MODE':
          this.$confirm(this.$t('switchTheMode') + mode + this.$t('mode'), '', {
            confirmButtonText: this.$t('determine'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning',
          }).then(() => {
            if (value === 'FLV') {
              this.liveMode = 'WEBRTC'
            } else {
              this.liveMode = 'FLV'
            }
            param.value = this.liveMode
            updateTranscribe(param)
            this.$store.commit('changeLiveMode', this.liveMode)
          })
          break
        default:
          break
      }

      // this.getTranscribe()
    },
    // 取消更新用户信息
    cancelUpdate() {
      this.userInfo = deepClone(this.originUserInfo)
      this.setAlertVisible = false
    },
    // 打开api秘钥弹窗
    showSecret() {
      this.secretVisible = true
    },

    // 从浏览器缓存中检查设备类型
    checkDeviceType(deviceTypeList) {
      if (deviceTypeList && deviceTypeList.length > 0) {
        let deviceSpecType = localStorage.getItem('DEVICE_SPEC_TYPE')
        for (let item of deviceTypeList) {
          if (deviceSpecType.indexOf(item + '') > -1) {
            return true
          }
        }
      }
    },
    // 从浏览器缓存中获取是否为超级管理用户
    checkIsAdmin() {
      let loginIsAdmin = sessionStorage.getItem('isAdmin')
      return loginIsAdmin === '1'
    },
    // 打开设置webhook窗口
    showWebHook() {
      if (!this.checkIsAdmin()) {
        return
      }
      this.webHookVisible = true
      this.getWebHook()
    },
    // 请求webhook参数
    getWebHook() {
      if (!this.checkIsAdmin()) {
        return
      }
      getWebHook().then(res => {
        if (res.state === 0 && res.data && res.data[0]) {
          this.formWebHook.id = res.data[0].id
          this.formWebHook.url = res.data[0].value
          this.webHookUrl = res.data[0].value
        }
      })
    },
    // 保存webhook回调地址
    saveWebHook() {
      if (!this.formWebHook.url && !this.formWebHook.id) {
        this.webHookVisible = false
        return
      }
      if (this.formWebHook.url && !this.checkWebHookUrL()) {
        errorCollection('个人设置', '设置webhook回调地址', {
          status: 200,
          data: { state: -1, msg: '请填写正确回调地址' },
        })
        this.$message({ type: 'error', message: this.$t('fillTheCorrect') })
        return
      }
      let params = {
        id: this.formWebHook.id,
        value: this.formWebHook.url,
      }
      if (!this.formWebHook.id) {
        saveWebHook(params).then(res => {
          if (res.state === 0) {
            this.webHookUrl = this.formWebHook.url
            this.webHookVisible = false
          }
        })
      } else {
        updateWebHook(params).then(res => {
          if (res.state === 0) {
            this.webHookUrl = this.formWebHook.url
            this.webHookVisible = false
          }
        })
      }
    },
    // 检查填入url是否正确
    checkWebHookUrL() {
      let sRegex =
        '^((https|http)?://)' +
        '(([0-9]{1,3}.){3}[0-9]{1,3}' + // IP形式的URL- 199.194.52.184
        '|' + // 允许IP和DOMAIN（域名）
        "([0-9a-zA-Z_!~*'()-]+.)*" + // 域名- www.
        '([0-9a-zA-Z][0-9a-z-]{0,61})?[0-9a-zA-Z].' + // 二级域名
        '[a-zA-Z]{2,6})' + // first level domain- .com or .museum
        '((:[0-9]{1,4})|)?' + // 端口- :80
        '((/?)|' + // a slash isn't required if there is no file name
        "(/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+/?)$"
      let re = new RegExp(sRegex)
      return re.test(this.formWebHook.url)
    },
  },
  watch: {
    $route: {
      handler() {
        this.toBound()
      },
      immediate: true,
    },
    getTheme(val) {
      this.theme = val
    },
    chatVisible(val) {
      if (val === false) {
        clearInterval(this.myVar)
      }
    },
  },
  mounted() {
    this.getWebHook()
    this.getUserInfo()
    this.getTranscribe()
  },
  computed: {
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    chatVisible() {
      return this.WechatVisible
    },
    isHuaWei: function() {
      return location.host.indexOf('huaweisoft.com') === -1 ? false : true
    },
    DEVICE_SPEC_TYPE: function() {
      return localStorage.getItem('DEVICE_SPEC_TYPE').indexOf('0') === -1 ? false : true
    },
    ...mapGetters(['isCloud', 'isDefaultTheme', 'isOnlySupportPosition']),
  },
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.myVar) // 在Vue实例销毁前，清除时间定时器
    }
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.person
  .help_icon
    background url('~@/icon/help_ic.png')
  .title
    width 90%
    margin 22px auto
  .main-content
    width 96%
    overflow hidden
    .bind
      float left
      width 62%
      font-size 16px
      .self
        display flex
        align-item center
        font-weight: bold
        line-height 46px
        .name
          margin 0 20px
        i
          height: 18px
          border-left 1px solid #BFBFBF
          margin auto 0
        .department
          margin 0 20px
      .phone-bind
        display flex
        line-height 85px
        overflow hidden
        .label-bind
          width 220px
          min-width 160px
          padding-left 20px
          font-weight 600
          span
            font-size 14px
        .content-bind
          width 600px
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          padding-left 34px
          font-weight: bold
          font-size 14px

          .explain
            margin-right 30px
        .bind-btn
          width 260px
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .el-button
            width 160px;/*no*/
            &.webhook-btn
              // width 120px
              // margin-left 10px
        .long-bind-btn
          // padding-left 20px
          .el-button--mini
            padding-left: 9px;
      .phone-bind-line-height
        line-height 82px
      .phone-bind-line-height-admin
        line-height 53px !important
    .code-img
      float left
      width 35%
      display flex
      flex-wrap wrap
      margin-left 23px
      border-top: none;
      .scan-code
        position relative
        width: 50%;
        text-align center
        cursor pointer
        .scan-title
          line-height 30px
          font-size 16px
          font-weight: 400
        img
          margin 16px 0
        .app-img
          margin 0  0 16px 0
        .help-img
          margin 8px  0
        .scan-tip
          position absolute
          bottom 0
          left 50%
          transform translate(-50%,0)
          width 90%
          line-height 20px
          font-size 12px
          color var(--personal-self-color)
.verificat-code
  position relative
  .phoneCode
    position absolute
    right -20px
    top 50%
    transform translate(0,-50%)
    width 110px
    background #86B2EE
    text-align center
    color #fff
    line-height 30px
    font-size 16px
    border-radius: 4px
    cursor pointer

#wxbox
  display flex
  justify-content center
#setAlertBox
  height 360px
  overflow auto
>>>.el-dialog
  .el-form-item
    margin-right 16px!important

@media screen and (max-width 1800px)
  .webhook-btn
    margin-left 0px !important
</style>
